module.exports = "https://sf6-scmcdn2-tos.pstatp.com/motor/pc/_next/static/images/live-stream-default-0937c7f89ce159c487fa26be61199669.png";